function initQtyButtons(scope = document) {
    scope.querySelectorAll(".quantity").forEach(function (el) {
        // éviter de recréer des boutons déjà existants
        if (el.querySelector(".qty-btn")) return;

        let input = el.querySelector(".qty");

        if (!input || input.type === "hidden" || input.style.display === "none") {
            el.classList.add("hidden");
            return;
        }

        let btnMinus = document.createElement("button");
        let btnPlus = document.createElement("button");
        btnMinus.innerHTML = "<i class='vn-icons-minus'></i>";
        btnPlus.innerHTML = "<i class='vn-icons-plus'></i>";
        btnMinus.className = "qty-btn minus";
        btnPlus.className = "qty-btn plus";
        btnMinus.type = "button";
        btnPlus.type = "button";

        el.insertBefore(btnMinus, input);
        el.appendChild(btnPlus);

        btnMinus.addEventListener("click", () => {
            if (input.value > 1) input.value--;
            triggerChange(input);
        });
        btnPlus.addEventListener("click", () => {
            input.value++;
            triggerChange(input);
        });
    });
}

function triggerChange(el) {
    el.dispatchEvent(new Event("change", { bubbles: true }));
}

// 🔥 initialisation au chargement
window.addEventListener("load", function () {
    initQtyButtons();

    // 🔄 Réappliquer après mise à jour AJAX du panier
    jQuery(document.body).on("updated_cart_totals", function () {
        initQtyButtons(document);
    });
});

jQuery(document.body).on("wc_fragment_refresh updated_wc_div", function () {
    initQtyButtons(document);
});